export default __webpack_public_path__ + "static/media/instyle-logo.1c8b0b6c.svg";